import React, { Component, PropTypes } from 'react';
import featureFlags from '../../../featureFlags'
import './overview.scss';

function noOp() {}

export default class Overview extends Component {

  static contextTypes = {
    session: PropTypes.object.isRequired,
    program: PropTypes.object.isRequired,
    setCurrentLevel: PropTypes.func.isRequired,
    setMode: PropTypes.func.isRequired,
    hideHUD: PropTypes.func.isRequired,
    staff: PropTypes.bool,
    i18n: PropTypes.func.isRequired
  }

  jumpToLevel (levelNumber) {
    const { setCurrentLevel, hideHUD } = this.context;
    setCurrentLevel(levelNumber);
    hideHUD();
  }

  hideHUD(evt) {
    evt.preventDefault();
    this.context.setMode(null);
    this.context.hideHUD();
  }

  render () {
    const { session, program, staff, i18n: _ } = this.context;
    const { currentLevel, completedLevel: sessionCompletedLevel } = session;
    const completedLevel = sessionCompletedLevel ? sessionCompletedLevel : 0;
    const { levels } = program;
    const levelRows = Object.keys(levels).map(levelKey => {
      const levelNumber = Number(levelKey);
      if (isNaN(levelNumber)) {
        return null;
      }
      const level = levels[levelKey];
      const { thumbnail, levelName } = level;
      const isCurrentLevel = levelNumber === Number(currentLevel);
      const canSkip = ((levelNumber <= completedLevel + 1) || staff || featureFlags.allowAnyoneToSkipBetweenLevels);
      return (
        <li key={`level${levelNumber}`}
            className={
              levelNumber === Number(currentLevel)
            ? 'current overview-level level-' + levelNumber
            : 'overview-level level-' + levelNumber
            }>
          <div className="overview-level-image">
            <img onClick={
              isCurrentLevel
                ? ::this.hideHUD
                : canSkip
                  ? this.jumpToLevel.bind(this, levelNumber)
                  : noOp
            } src={thumbnail}/>
          </div>
          <div className="overview-level-info">
            <h2>{_`Level ${levelNumber}:`} <span>{_(levelName)}</span>
            </h2>
          </div>
          <div className="overview-level-status">
          { isCurrentLevel &&
            <button
                className="btn btn-sm btn-current"
                onClick={::this.hideHUD}>
              {_('In Progress')}
            </button>
          }
          { levelNumber !== Number(currentLevel) &&
            canSkip &&
            <button
                className="btn btn-sm btn-default"
                onClick={this.jumpToLevel.bind(this, levelNumber)}>
              { levelNumber >= Number(currentLevel)
              ? _('Skip to Level')
              : _('Back to Level')
              }
            </button>
          }
          { levelNumber !== Number(currentLevel) &&
            !canSkip &&
            <button
                className="btn btn-sm btn-link" disabled>
              {_('Restricted')}
            </button>
          }
          </div>
        </li>
      );
    });

    return (
      <div
          className="overview">
        <h1>{_('Modules')}</h1>
        <ul
            className="overview-levels scroller-panel">
          {levelRows}
        </ul>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/hudTeacherRemote/overview/index.jsx